module.exports = __webpack_public_path__ + "static/media/2000d.664b5e8a.jpg";